import {createGrid} from "../../../helpers/grids/grids";
import {loading} from "../../../helpers/loading";
import {createCellRenderer, createDoubleClickHandler} from "../../../helpers/grids/helpers";
import createElement from "../../../helpers/createElement";

function initProductionAuditionsScheduleIndex() {

	const grid = createGrid('.auditions-schedule-grid', {
			columnDefs: [
				{
					field: "start_date",
					headerName: 'Date',
					sortable: true,
					autoHeight: true,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedReference
						return createElement(`
							<div style="line-height: 1">
								<div>${params.data.formatted_date}</div>
								<div>${params.data.formatted_time_string}</div>
							</div>
						`)
					}),
					minWidth: 200,
					maxWidth: 210,
					suppressAutoSize: true,
				},
				{
					field: "public_id",
					headerName: 'Actor',
					sortable: false,
					wrapText: true,
					autoHeight: true,
					minWidth: 300,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedReference
						const requestFullName = params.data.request_full_name;
						// noinspection JSUnresolvedReference
						const requestRoles = params.data.request_roles_string;

						if (requestFullName) {
							return createElement(`
								<div> <b>${requestFullName}</b> As <b>${requestRoles}</b></div>
							`)
						} else {
							return createElement(`
								<div class="text-muted">Available</div>
							`)
						}
					})
				},
			],
			pagination: false,
			paginationPageSize: 200,
			_rowName: 'Slots',
			getRowClass: (params) => {
				// noinspection JSUnresolvedReference
				if (params.data.is_available) {
					return 'available'
				} else {
					return 'taken';
				}
			},
			onRowDoubleClicked: createDoubleClickHandler(data => {
				// noinspection JSUnresolvedVariable
				if (data.view_url) {
					loading();
					window.location.href = data.view_url;
				}
			}),
		},
		window['routes/admin.productions.auditions-schedule.grid']
	);

	/** Methods */

}

export {
	initProductionAuditionsScheduleIndex
}
